import { render, staticRenderFns } from "./FormularioPage.vue?vue&type=template&id=98840274"
import script from "./FormularioPage.vue?vue&type=script&lang=js"
export * from "./FormularioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports